import React from "react";
import { Helmet } from "react-helmet-async";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import "./dashboard.scss"

import {ReactComponent as DMSLogo} from "../../assets/images/RDMS-Logo.svg";

const Dashboard = (props) => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Helmet>
          <title>Braskem RDMS</title>
        </Helmet>
        <Container fluid>
          <Row>
            <Col xs="12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 font-size-18">Main Page</h4>
              </div>
            </Col>
          </Row>
          <Row>
            <Card>
              <CardBody className="p-2 p-md-5">
                <Row>
                  <DMSLogo />
                </Row>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
